import axios from "../../axios";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_MOBILE_BASE_URL = process.env.REACT_APP_API_MOBILE_BASE_URL;
const API_PAL_URL = process.env.REACT_APP_API_PAL_URL

const kycStatusCheck = async (data) => {
  const response = await axios({
    url: `${API_BASE_URL}kyc/status/${data?.reference_id}`,
    method: "GET"
  });
  return response?.data;
}

const productFetch = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/search-product-info',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const productSubmit = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/selected-scheme',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const skuSubmit = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/sku-details',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const dealerSelfie = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'kyc/dealer-selfie',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const selectedScheme = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/selected-scheme',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const kycLink = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'kyc/request',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const getApplicationData = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'common/get-status',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const sendMandateLink = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'mandate/initiate',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const checkmandateStatus = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'mandate/get-mandate-Status',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const documentGenerate = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'documents/generate',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const productDetails = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/product-detail',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const imeiValidation = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/imei-validation',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const updateImeiDetails = async (data) => {
  const response = await axios({
    url: API_MOBILE_BASE_URL + 'Screen_bros/update_imei_details',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const getImeiDetails = async (data) => {
  const response = await axios({
    url: API_MOBILE_BASE_URL + 'Screen_bros/get_imei_status',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const emiDetails = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/emi-details',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const documentCallback = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'documents/callback',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const addOnDetails = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/addon-details',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const addOnSubmit = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/addon-submit',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const invoiceSubmit = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/invoice-upload',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const stageSubmit = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/status-update',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const checkIfscCode = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'mandate/get-ifsc-details',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const panOcr = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/pan-ocr',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const sendMail = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'documents/send-mail',
    method: "POST",
    data: data,
  });
  return response?.data;
}
//emiProductFetch
const emiProductFetch = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/emicalc-product-info',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const emiSkuSubmit = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/emi-details-sku',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const emiCalculation = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/emi-calculator',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const caseConfirmation = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/confirmation',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const anmolCheck = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/anmol-check',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const etbSummary = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'kyc/kyc-summary',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const verifyEsignOtp = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'documents/esign',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const etbCheck = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'mandate/etb-check',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const mandateCheck = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'mandate/confirmation',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const editedKycSubmit = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'kyc/detail-update',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const sendEmailOtp = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'kyc/email-verify',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const sendMobileOtp = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'kyc/mobileno-verify',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const verifyEmailOtp = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'kyc/email-verify',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const verifyMobileOtp = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'kyc/mobileno-verify',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const employerSearch = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'ops/documents/search',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const getBankIfsc = async (data) => {
  const response = await axios({
    url: `${API_BASE_URL}master/ifsc/${data?.bank_name}/${data?.branch_name}`,
    method: "GET"
  });
  return response?.data;
}

const pincodeSearch = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'common/zipcode',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const caseSearch = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'credit-decision/get-details',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const dealerCheck = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'product/dealer-product-check',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const shareLink = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'documents/generate',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const hyperverge = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'mandate/qrstart',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const hypervergecheck = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'mandate/qrstatus',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const cKycCheck = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'ckyc/check',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const cKycOtpGenerate = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'ckyc/generate_otp',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const cKycOtpValidate = async (data) => {
  const response = await axios({
    url: API_BASE_URL + 'ckyc/validate',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const fetchLeadDetails = async (data) => {
  const response = await axios({
    url: API_PAL_URL + 'pal/list',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const fetchLeadDataDetails = async (data) => {
  const response = await axios({
    url: API_PAL_URL + 'pal/customer-details',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const fetchSfeData = async (data) => {
  const response = await axios({
    url: API_PAL_URL + 'pal/sfe-dealers',
    method: "POST",
    data: data,
  });
  return response?.data;
}

const fetchRemarkData = async (data) => {
  const response = await axios({
    url: API_PAL_URL + 'pal/config/remarks',
    method: "GET",
    data: data,
  });
  return response?.data;
}

const SubmitLead = async (data) => {
  const response = await axios({
    url: API_PAL_URL + 'pal/update-lead',
    method: "POST",
    data: data,
  });
  return response?.data;
}

/*******  b8c451d4-eefd-4dcd-8a74-22a658bd3840  *******/

const eligibilityService = {
  kycStatusCheck, productFetch, productSubmit, skuSubmit, dealerSelfie, selectedScheme, kycLink, getApplicationData, sendMandateLink, checkmandateStatus, documentGenerate, productDetails, imeiValidation, updateImeiDetails, getImeiDetails, emiDetails, documentCallback, addOnDetails, addOnSubmit, invoiceSubmit, stageSubmit, checkIfscCode, panOcr, sendMail, emiProductFetch, emiSkuSubmit, emiCalculation, caseConfirmation, anmolCheck, etbSummary, verifyEsignOtp, etbCheck, mandateCheck,editedKycSubmit, sendEmailOtp, verifyEmailOtp, employerSearch, pincodeSearch, sendMobileOtp, verifyMobileOtp, getBankIfsc, caseSearch, dealerCheck, shareLink, hyperverge, hypervergecheck, cKycCheck, cKycOtpGenerate, cKycOtpValidate, fetchLeadDetails, fetchLeadDataDetails, fetchSfeData, fetchRemarkData, SubmitLead
};

export default eligibilityService;
